import { FormattedMessage, useIntl } from 'react-intl';

import Button, { LinkButton } from '@atlaskit/button/new';
import { ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import { Text, Stack } from '@atlaskit/primitives';

import { SAC_URL } from '@/common/routes/constants';

import { messages } from '../messages';

export const RequestAssistanceModalEmpty = ({
	handleCloseModal,
}: {
	handleCloseModal: () => void;
}) => {
	const intl = useIntl();

	return (
		<>
			<ModalBody>
				<Stack space="space.200">
					<Text>
						<FormattedMessage {...messages.requestAssistanceModalEmptyDescription} />
					</Text>
				</Stack>
			</ModalBody>
			<ModalFooter>
				<Button
					appearance="subtle"
					onClick={handleCloseModal}
					aria-label={intl.formatMessage(messages.requestAssistanceModalCancelButtonAriaLabel)}
				>
					<FormattedMessage {...messages.requestAssistanceModalCancelButton} />
				</Button>
				<LinkButton
					appearance="primary"
					target="_blank"
					href={`${SAC_URL}/contact`}
					aria-label={intl.formatMessage(messages.requestAssistanceModalRaiseTicketLinkAriaLabel)}
				>
					<FormattedMessage {...messages.requestAssistanceModalEmptyModalRaiseTicketButton} />
				</LinkButton>
			</ModalFooter>
		</>
	);
};
